import { GoogleSpreadsheet } from "google-spreadsheet";

const google = process.env.VUE_APP_GOOGLE || "{}";
const googleParse = JSON.parse(google);
export default sheetId => ({
  data: () => ({}),
  methods: {
    async addNewRowToSheetByTitle(title, newRow = []) {
      if (!title || !newRow) {
        return;
      }
      const doc = new GoogleSpreadsheet(sheetId);
      await doc.useServiceAccountAuth({
        client_email: googleParse.client_email,
        private_key: googleParse.private_key
      });
      await doc.loadInfo();
      const sheet = doc.sheetsByTitle[title];
      await sheet.addRow(newRow);
    }
  }
});
